


















































import Vue from 'vue'
import AutocompleteField from '@/UI/Shared/AutocompleteField.vue'

export default Vue.extend({
  name: 'AdvancedSearch',
  components: { AutocompleteField },
  data () {
    return {
      currentValue: '',
      toggled: false
    }
  },
  methods: {
    onSearchRequested () {
      this.toggled = false
      this.$emit('search-requested')
    },
    onSearchCleaned () {
      this.toggled = false
      this.$emit('search-cleaned')
    }
  }
})
